import { GraphQLClient } from "graphql-request";
import { getSdk } from "~/graphql/generated";

export function createGqlClient(accessToken: string): GraphQLClient {
  return new GraphQLClient(import.meta.env.VITE_GATEWAY_URL, {
    headers: { authorization: `Bearer ${accessToken}` },
  });
}

export function createSdk(accessToken: string) {
  return getSdk(createGqlClient(accessToken));
}
